module.exports = __webpack_public_path__ + "static/media/feature-cloud-hosted.5933ba5b.svg";